export default __webpack_public_path__ + "static/media/convertise-horizontal-negative.8467e5ce.svg";